import { nativeCommsBroadcastMessageTypes } from "../../../nativeComms";
import nativeCommsMessageTypes from "../../../nativeComms/nativeCommsMessageTypes";

let menus = [];

//#!if readonly === true
menus = [
  nativeCommsBroadcastMessageTypes.FILE_OPEN,
  "openRecent",
  nativeCommsBroadcastMessageTypes.FILE_CLOSE,
  nativeCommsBroadcastMessageTypes.FILE_CLOSE_ALL,
  "Export",
  nativeCommsMessageTypes.FILE_PRINT,
  nativeCommsMessageTypes.SHOW_PREFERENCES,
  nativeCommsBroadcastMessageTypes.FILE_EXIT
];
//#!endif

export default menus;
